import { createSlice } from "@reduxjs/toolkit";
import { fetchWaitlistItems } from "./WaitlistThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const waitlistSlice = createSlice({
  name: "waitlist",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchWaitlistItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWaitlistItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchWaitlistItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default waitlistSlice.reducer;